export const TOPSORT_URL_BASE = 'https://api.topsort.com/v2';

export const TOPSORT_URL_EVENTS = `${TOPSORT_URL_BASE}/events`;

export const TOPSORT_URL_AUCTIONS = `${TOPSORT_URL_BASE}/auctions`;
